<template>
  <b-modal
    id="building-emergency-modal"
    title="Building Emergency Modal"
    centered
    hide-footer
    size="xl"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    @shown="onModalShown"
  >
    <template #modal-title>
      <h2 class="m-0">Building Emergency</h2>
    </template>

    <b-table
        responsive="sm"
        :fields="fields"
        :items="building_emergency_data"
        details-td-class="m-0 p-0"
        small
        :per-page="0"
        :tbody-tr-class="rowClass"
      > 
        <template #cell(name)="row">          
          <b-link style="padding-right: 15px; color: black;" @click="row.toggleDetails" v-if="row.item.user_data.is_peep">
            <feather-icon  icon="PlusSquareIcon" /> 
          </b-link>
            {{
              row.item.user_data ? row.item.user_data.name : ""
            }}          
        </template>

        <template #cell(phone_number)="row">
            {{
              row.item.user_data ? row.item.user_data.mobile_number : ""
            }}
        </template>


        <template #cell(building_data)="row">
            {{
              row.item.building_data ? row.item.building_data.name : ""
            }}
        </template>

        <template #cell(is_peep)="row">
            {{
              row.item.user_data.is_peep ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(is_active)="row">
            {{
              row.item.is_active === true ? 'Yes' : 'No'
            }}
        </template>


        <template #cell(in_building)="row">
            {{
              row.item.in_building ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(exit_building)="row">
            {{
              row.item.exit_building ? 'Yes' : 'No'
            }}
        </template>

        <template #cell(reached_assembly_area)="row">
            {{
              row.item.reached_assembly_area ? 'Yes' : 'No'
            }}
        </template>

        <template #row-details="row">
          <b-card bg-variant="light" border-variant="dark">
            <b-table
              responsive="sm"
              :fields="user_flats_fields"
              :items="row.item.nominee_data"
              details-td-class="m-0 p-0"
              small
            >
            </b-table>
          </b-card>
        </template>

        <template #cell(role_data)="row">
          {{ row.item.role_data ? row.item.role_data.name : "" }}
        </template>        
        <template #cell(profile_status)="row">
          <b-badge :variant="badgeVariant(row.item.profile_status)">
            {{ row.item.profile_status }}
          </b-badge>
        </template>
        <template #cell(has_pending_flats)="row">
          {{ row.item.has_pending_flats ? 'Yes' : 'No' }}
        </template>  
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>

  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  props: {
    floor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      building_emergency_data_list: [],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      fields: [
        { key: "name", label: "Name" },
        { key: "phone_number", label: "Contact Number" },
        { key: "building_data", label: "Building" },
        { key: "is_peep", label: "PEEP Status" },
        { key: "is_active", label: "Response on Alert" },
        { key: "in_building", label: "In Building" },
        { key: "exit_building", label: "Exited From Building" },
        { key: "reached_assembly_area", label: "Reached Assembly Area" },
        { key: "updated_at", label: "Last Update At" },
      ],
    };
  },
  methods: {
    ...mapActions({
      getFlatUsers: "appData/getFlatUsers",
    }),
    async onModalShown() {
      console.log("Modal is shown", this.floor);
      try {
        const res = await this.getFlatUsers({
          pageNumber: this.currentPage,
          building : this.floor.building_id,
          floor : this.floor.floor_id,
        });
        this.building_emergency_data = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page
        console.log("Building Emergency Data:", this.building_emergency_data);
      } catch (error) {
        this.displayError(error);
      }
    },

    
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  
};
</script>

<style>

</style>
